import { FieldConfig, FormConfig } from '@acme/foundation';

export const AddWalletAddressesFormConfig = (
  includeUnchangedFields: boolean = true,
  wallets: number,
  withLabel: boolean = false
): FormConfig => {
  const rates: FieldConfig[] = Array.from({ length: wallets }).flatMap(
    (r, idx) => {
      return {
        id: `wallet-${idx}`,
        type: 'text',
        ...(withLabel && { label: 'Адрес криптокошелька' }),
        read: (ctx: any) => ctx?.[`wallet-${idx}`] || '',
        write: { path: `wallet-${idx}` },
        props: {
          placeholder: 'Введите или вставьте адрес',
        },
      };
    }
  );

  return {
    id: 'add-wallet-addresses-form',
    includeUnchangedFields, // возвращаем все поля или только измененные
    controls: [...rates],
  };
};
